import { IActivityTax } from '@common-types';

/**
 * Total taxes charged now on the card for an activity rate.
 *
 * Mirrors the hotels/cars/condos behaviour: wallet points may cover the base travel price, but
 * taxes must always be charged to the card. We only sum taxes that are mandatory (`!isOptional`)
 * and collected at booking (`!atProperty`) — taxes collected at the property are paid on site and
 * are not part of the amount charged now.
 */
export const getActivityTaxesTotal = (taxes: IActivityTax[] | null | undefined): number => {
    if (!Array.isArray(taxes) || taxes.length === 0) {
        return 0;
    }
    return taxes.reduce(
        (sum, tax) => (tax && !tax.atProperty && !tax.isOptional ? sum + (Number(tax.amount) || 0) : sum),
        0
    );
};
